import React, { Component } from 'react';
import _ from 'lodash';

import SessionStorageService from '../services/utilities/SessionStorageService';
import LwGroupTable from '../components/tables/LwGroupTable';
import {
  LwGroupRegisterModal,
  LwGroupEditModal,
} from '../components/lwUser/topModalGroup';
import LwGroupApi from '../services/LwGroupApi';
import { Confirmation } from '../components/modals/common';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import { messageUtility } from '../utilities/messageUtility';
import { FieldService } from '../services/Fields';
import _slideLoader from '../utilities/slideLoader';
import urlParamManager from '../utilities/urlParamManager';
import Helmet from 'react-helmet';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { ConferencePageHeader } from '../components/PageHeader';
import { Description } from '../components/Description';

const LwGroupLayout = ({ children, vw }) => {
  const handleCloseSlide = () => {
    _slideLoader.close(vw);
  };
  const slide = urlParamManager.getSlideParam();

  return (
    <div className='LineGroups'>
      <div className='slide-view show'>
        {slide[0] === '0' && ( // リロード時他ページのtitleを上書きする問題の対策
          <Helmet>
            <title>
              {HEADER_CONSTANTS.conference} - LINE WORKS グループ一覧
            </title>
          </Helmet>
        )}
        <div className='slide-view__view'>
          <ConferencePageHeader
            onClose={handleCloseSlide}
            title='LINE WORKS グループ一覧'
          />
          {children}
        </div>
      </div>
    </div>
  );
};

export class LwGroups extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldTreeId: SessionStorageService.getFieldTreeId(),
      lineGroups: [],
      isDisplayCreateDialog: false,
      isDisplayUpdateDialog: false,
      isDisplayDeleteDialog: false,
      lwGroupId: null,
      lwGroupName: null,
      isLoading: true,
      updatedCss: false,
      field: {
        id: SessionStorageService.getFieldId(),
        name: '',
      },
    };
    this.isDeleteFlag = false;
  }

  componentDidMount() {
    this.setFieldNameById(this.state.field.id);
    this.loadLwGroups();
    const message = document.querySelector('.global-header__message');
    const divFixed = document.querySelector('.fixed-scroller-header');
    if (message) {
      divFixed.style.height = 'calc(100vh - 122px)';
      this.setState({ updatedCss: true });
    } else {
      divFixed.addEventListener('scroll', () => {
        const message = document.querySelector('.global-header__message');
        if (message && !this.state.updatedCss) {
          divFixed.style.height = 'calc(100vh - 122px)';
          this.setState({ updatedCss: true });
        }
      });
    }
  }

  componentWillUnmount() {
    const divFixed = document.querySelector('.fixed-scroller-header');
    divFixed.removeEventListener('scroll', () => {});
  }

  setFieldNameById(fieldId) {
    if (fieldId) {
      FieldService.info(fieldId).then(response => {
        if (response.result) {
          this.setState({
            field: {
              id: fieldId,
              name: response.data.entities.field.name,
            },
          });
        }
      });
    }
  }

  lwRefreshList = () => {
    this.setState(
      {
        isLoading: true,
      },
      this.loadLwGroups
    );
  };

  loadLwGroups = async () => {
    const { result, data } = await LwGroupApi.list(this.state.field.id);
    if (result && data.total > 0) {
      this.setState({
        lineGroups: _.get(data, 'entities.lw_groups', []),
        isLoading: false,
      });
    } else {
      this.setState({
        lineGroups: [],
        isLoading: false,
      });
    }
  };

  showModalCreate = () => {
    this.setState({ isDisplayCreateDialog: true });
  };

  showModalUpdate = (lwGroupId, lwGroupName) => {
    this.setState({
      isDisplayUpdateDialog: true,
      lwGroupId,
      lwGroupName,
    });
  };

  toggleDialogDelete = lwGroupId => {
    const { isDisplayDeleteDialog } = this.state;
    this.setState({ isDisplayDeleteDialog: !isDisplayDeleteDialog }, () => {
      this.setState({ lwGroupId });
      if (!this.state.isDisplayDeleteDialog) {
        this.lwRefreshList();
      }
    });
  };

  deleteLwGroup = async () => {
    if (this.isDeleteFlag) {
      return;
    }
    this.isDeleteFlag = true;
    await LwGroupApi.destroy(this.state.field.id, this.state.lwGroupId);
    this.isDeleteFlag = false;
    this.setState({
      isDisplayDeleteDialog: false,
      lwGroupId: null,
    });
    this.lwRefreshList();
  };

  render() {
    const { vw } = this.props;
    const {
      isDisplayCreateDialog,
      isDisplayUpdateDialog,
      isDisplayDeleteDialog,
      lineGroups,
      lwGroupId,
      lwGroupName,
      field,
    } = this.state;
    return (
      <LwGroupLayout vw={vw}>
        <div className='master-slide-view__table fixed-scroller-header'>
          <header>
            {lineGroups.length === 0 ? (
              <button className='btn' onClick={this.showModalCreate}>
                新規作成
              </button>
            ) : (
              <Description>
                グループは1現場につき1つまでしか登録できません。
              </Description>
            )}
          </header>
          <main>
            <div>
              <LwGroupTable
                lineGroups={this.state.lineGroups}
                onUpdate={(lwGroupId, lwGroupName) =>
                  this.showModalUpdate(lwGroupId, lwGroupName)
                }
                toggleDialogDelete={id => this.toggleDialogDelete(id)}
              />
              <InfinityScrollLoad
                isLoading={this.state.isLoading}
                total={_.size(this.state.lineGroups)}
                no_data_message={messageUtility.getMessage('I-000-005')}
              />
            </div>
          </main>
          <Confirmation
            title='グループ削除'
            message='このグループを削除します。よろしいですか？'
            confirmButtonText='削除する'
            cancelButtonText='戻る'
            visible={isDisplayDeleteDialog}
            isNegative={true}
            onCancel={() => this.toggleDialogDelete(null)}
            onConfirm={this.deleteLwGroup}
            isSubmitting={this.isDeleteFlag}
          />
          {isDisplayCreateDialog && (
            <LwGroupRegisterModal
              fieldId={field.id}
              fieldName={field.name}
              clickBack={() => {
                this.lwRefreshList();
                this.setState({ isDisplayCreateDialog: false });
              }}
              clickSubmit={() => {
                this.lwRefreshList();
                this.setState({ isDisplayCreateDialog: false });
              }}
            />
          )}
          {isDisplayUpdateDialog && (
            <LwGroupEditModal
              fieldId={field.id}
              fieldName={field.name}
              lwGroupId={lwGroupId}
              lwGroupName={lwGroupName}
              clickBack={() => {
                this.lwRefreshList();
                this.setState({ isDisplayUpdateDialog: false });
              }}
              clickSubmit={() => {
                this.lwRefreshList();
                this.setState({ isDisplayUpdateDialog: false });
              }}
            />
          )}
        </div>
      </LwGroupLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/LwGroups.jsx